// src/components/layout/TryNewDeckBanner.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { TRY_NEW_DECK_PATH, shouldShowTryNewBanner } from '../../utils/promoChrome';
import { usePageLeaveGuard } from './PageLeaveGuardContext';
import './TryNewDeckBanner.css';

function TryNewDeckBanner() {
    const { navigate } = usePageLeaveGuard();
    if (!shouldShowTryNewBanner()) return null;

    return (
        <a
            className="try-new-deck-banner"
            href={TRY_NEW_DECK_PATH}
            aria-label="Try New Builder Now!"
            onClick={(event) => {
                event.preventDefault();
                navigate(TRY_NEW_DECK_PATH);
            }}
        >
            <FontAwesomeIcon icon={faLayerGroup} className="try-new-deck-banner-icon" />
            <span className="try-new-deck-banner-title header-label-full">Try New Builder Now!</span>
            <span className="try-new-deck-banner-title header-label-short">New Builder</span>
        </a>
    );
}

export default TryNewDeckBanner;
